<template>
  <v-btn @click="this.$router.push('/')" elevation="0" icon>
    <v-icon color="red-darken-4">mdi-arrow-left</v-icon>
  </v-btn>
  <v-col cols="12" md="8" class="mx-auto">
    <div class="d-flex mt-10">
      <v-layout style="min-height: 30vh" class="mb-15">
        <v-navigation-drawer v-model="drawer" :rail="rail" permanent>
          <v-tabs
            v-model="tab"
            density="compact"
            direction="vertical"
            color="red-darken-4"
            nav
          >
            <v-tab
              prepend-icon="mdi-account"
              :to="'/meusDados/usuario'"
              value="account"
              >{{ !rail ? "Meus Dados" : "" }}</v-tab
            >
            <v-tab
              prepend-icon="mdi-moped-outline"
              :to="'/meusDados/pedidos'"
              value="requests"
              >{{ !rail ? "Meus Pedidos" : "" }}</v-tab
            >
          </v-tabs>
        </v-navigation-drawer>
        <v-main>
          <v-btn
            variant="text"
            icon="mdi-chevron-left"
            @click.stop="rail = !rail"
          ></v-btn>
          <v-col cols="12" v-if="tab == 'account'">
            <router-view></router-view>
          </v-col>
          <v-col v-if="tab == 'requests'">
            <router-view></router-view>
          </v-col>
          <v-btn
            v-if="floatingButton"
            @click="scrollTop"
            style="position: fixed; bottom: 10px; right: 25px"
            variant="plain"
            icon
            color="red-darken-4"
          >
            <v-icon color="red-darken-4">mdi-arrow-up</v-icon>
          </v-btn>
        </v-main>
      </v-layout>
    </div>
  </v-col>
  <div class="powered-by">
    <div>
      <span>Powered by </span>
    </div>
    <div>
      <img
        :src="image"
        alt="ibologo"
        style="height: 90px; margin-top: -25%; margin-bottom: -25%"
      />
    </div>
  </div>
</template>

<script>
var image = require("../../assets/logowithtext.svg");

export default {
  name: "meusDadosPedidos",
  data: () => ({
    empresas: [],
    registerLimit: 5,
    selectedEmpresa: null,
    empresasData: [],
    pedisosData: [],
    tab: "account",
    selectedPedidos: "Em Andamento",
    drawer: true,
    rail: true,
    floatingButton: false,
    edit: [false, false, false, false, false, false],
    formValido: false,
    items: [
      {
        title: "Meus Dados",
        value: 1,
        props: {
          prependIcon: "mdi-user",
        },
      },
      {
        title: "Acompanhamento",
        value: 2,
      },
    ],
    registroEdit: {
      endereco: "",
      bairro: "",
      cidade: "Passo Fundo",
      nome: "",
      whatsapp: "",
      telefone: "",
      sobrenome: "",
    },
    image: image,
    teste: "",
  }),
  mounted() {
    this.$router.currentRoute.value.fullPath == "/meusDados"
      ? this.$router.push("/meusDados/usuario")
      : "";
  },
};
</script>

<style lang="scss" scoped>
.powered-by {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding: -8px;
}
</style>
